import React, { useState } from "react";
import { Button, Popover } from "@mui/material";
import {
  KeyboardArrowDown as DownIcon,
  KeyboardArrowUp as UpIcon,
} from "@mui/icons-material";

import { COLORS } from "common/colors";

import "./styles.css";

interface defaultProps {
  text: string;
  children: React.ReactNode;
  align?: "top" | "bottom";
  type?: "contained" | "outlined";
  color?: string;
  border?: string;
  onClose?: Function;
  className?: string;
}

const PopoverBtn = (props: defaultProps) => {
  const { text, children, align, type, color, border, onClose, className } =
    props;
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handlePopoverClose = () => {
    console.log("PopoverBtn: handlePopoverClose: ");
    setAnchorEl(null);
    onClose();
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (anchorEl) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const open = Boolean(anchorEl);

  console.log("PopoverBtn: open: ", open);

  return (
    <>
      <Button
        variant={type || "outlined"}
        onClick={handleClick}
        className={className}
      >
        {text}
        {open ? (
          <UpIcon
            style={{
              color: color || COLORS.PRIMARY,
              position: "relative",
              top: -2,
              right: -2,
            }}
          />
        ) : (
          <DownIcon
            style={{
              color: color || COLORS.PRIMARY,
              position: "relative",
              right: -2,
            }}
          />
        )}
      </Button>
      <Popover
        style={{
          marginTop: "0.8rem",
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={
          align === "top"
            ? {
                vertical: "top",
                horizontal: "center",
              }
            : {
                vertical: "bottom",
                horizontal: "center",
              }
        }
        transformOrigin={
          align === "top"
            ? {
                vertical: "bottom",
                horizontal: "center",
              }
            : {
                vertical: "top",
                horizontal: "center",
              }
        }
        onClose={handlePopoverClose}
      >
        <div className="popOver">{children}</div>
      </Popover>
    </>
  );
};

export default PopoverBtn;
